import React from "react";
import { Row, Col } from "react-bootstrap";
import DatePresetFilter from "./DatePresentFilter";
import TooltipHelper from "../../../components/TooltipHelper";

interface FilterProps {
  setDateFilter: (range: [number, number] | undefined) => void;
  reportDate: string;
}

export default function Filter(props: FilterProps) {
  return (
    <React.Fragment>
      <div className="d-flex">
        <h4 className="font-weight-bold">Filters</h4>
        <TooltipHelper
          text={
            <text>
              Date filters are applied to the Total Confirmed COVID Counts
              tiles, the graphs for cases, tests, deaths, and positive test rate
              by day, resource usage by day, and hospitalization graphs. A{" "}
              <i className="far fa-calendar"></i> above the data feature
              signifies it is being filtered to a specific date range.
            </text>
          }
        />
      </div>
      <Row className="mb-3">
        <Col>
          <span className="h6 mr-4">Date Range </span>{" "}
          <DatePresetFilter {...props} />
        </Col>
      </Row>
    </React.Fragment>
  );
}
